import { JSX } from 'preact';
import { useCallback } from 'preact/hooks';

import { Modal } from '../UNSAFE_Modal';
import { WindowOverlay } from '../UNSAFE_WindowOverlay';
//Temporal import.
import { useSheetSwipe } from './useSheetSwipe';

import { sheetMenuStyles } from './themes/SheetStyles.css';
/*
  pointerDismissed: Swipedown and tapScrim
  keyboardDismissed: "Escape" | "Tab"
*/
type CloseDetail = { reason: 'pointerDismissed' | 'keyboardDismissed' };

type IntrinsicProps = Pick<JSX.HTMLAttributes<HTMLDivElement>, 'children'>;

type SheetProps = IntrinsicProps & {
  onClose?: (detail: CloseDetail) => void;
  isOpen?: boolean;
};

export const Sheet = ({ children, onClose, isOpen = false }: SheetProps) => {
  const handlePointerDismissed = useCallback(() => {
    onClose?.({ reason: 'pointerDismissed' });
  }, [onClose]);

  // TODO: Use useSwipe when it works on components that could scroll. Important to notice all components that have a
  // sheet will use this comp and this comp is going to use useSwipe. So comps that have their own impl (menu right now),
  // will stop having its own implementation
  const { swipeProps } = useSheetSwipe(handlePointerDismissed);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.defaultPrevented) {
        return;
      }
      switch (event.code) {
        case 'Tab':
        case 'Escape':
          onClose?.({ reason: 'keyboardDismissed' });
        default:
          break;
      }
    },
    [onClose]
  );

  return (
    <Modal isOpen={isOpen} onBackdropClick={handlePointerDismissed}>
      <WindowOverlay placement="bottom">
        <div
          {...swipeProps}
          class={sheetMenuStyles.sheetMenuContainerWrapper}
          style={{ maxHeight: `calc(100vh - ${TOP_OFFSET}px)` }}
          onKeyDown={handleKeyDown}>
          {children}
        </div>
      </WindowOverlay>
    </Modal>
  );
};

const TOP_OFFSET = 96;
